module.exports = __webpack_public_path__ + "static/media/1.b01b2849.jpg";